import { Theme } from '@mui/material';
import { useInnovyzeTheme } from './innovyzeTheme';
import useWeaveThemeMaterial from './weaveThemeMaterial';
import { useWeaveThemeContext } from '../WeaveContext';
import { INFO360_THEMES, ThemeMode } from '../theme.types';

interface useDefaultThemeProps {
	defaultTheme?: INFO360_THEMES;
}

export default function useDefaultTheme({
	defaultTheme,
}: useDefaultThemeProps): Theme {
	const { theme, weaveThemeConsumer } = useWeaveThemeContext();
	const weave = {
		resolvedRoles: weaveThemeConsumer?.resolvedRoles,
		metadata: weaveThemeConsumer?.metadata,
	};

	const selectedTheme = theme ?? defaultTheme ?? INFO360_THEMES.Classic;
	const mode =
		selectedTheme === INFO360_THEMES.Dark
			? ThemeMode.Dark
			: ThemeMode.Light;

	// Get theme objects.
	const innovyzeTheme = useInnovyzeTheme();
	const { theme: weaveTheme } = useWeaveThemeMaterial(weave, mode);

	if (
		!weave.resolvedRoles ||
		!weave.metadata ||
		selectedTheme === INFO360_THEMES.Classic
	) {
		return innovyzeTheme;
	}
	return weaveTheme;
}
